import { myAccount } from '@consumer/api'
import { usePage, useSharedData } from '@consumer/composables/sharedData'
import { openAddUsernameModal } from '@consumer/services/modals'

const SESSION_KEY = 'username_modal_shown'

// This prompt opens after an async call, so on a page that opens its own modal on
// load it lands on top and buries it.
const SKIPPED_PAGES = ['CheckoutOrderConfirmation']

async function promptIfNeeded (currentUser: { usernameNeedsConfirmation?: boolean } | undefined) {
  if (!currentUser?.usernameNeedsConfirmation) {
    sessionStorage.removeItem(SESSION_KEY)
    return
  }
  if (sessionStorage.getItem(SESSION_KEY)) return

  try {
    const { suggestedUsername } = await myAccount.suggestUsername({ visit: false })
    if (suggestedUsername) {
      openAddUsernameModal(suggestedUsername)
      sessionStorage.setItem(SESSION_KEY, '1')
    }
  }
  catch (error) {
    console.error('Failed to fetch suggested username:', error)
  }
}

// For Inertia pages (called from BaseLayout.vue)
export function useAddUsernamePrompt () {
  const { currentUser } = $(useSharedData())
  const { component } = $(usePage())

  onMounted(() => {
    watch(() => component, (page) => {
      if (SKIPPED_PAGES.includes(page)) return

      promptIfNeeded(currentUser)
    }, { immediate: true })
  })
}

// For Phlex pages (called from consumer_phlex.ts entrypoint)
export function checkAddUsernamePrompt () {
  const props = window.InertiaProps
  promptIfNeeded(props?.currentUser || props?.current_user)
}
